export const helper = {

 formatMoneyKES(n: number) {
  const s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return ` ${s}`; //KES
},

 compactDate(dt?: string) {
  if (!dt) return "";
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return dt;
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
},
compactDateTime(dt?: string) {
  if (!dt) return "";
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return dt;
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
},
truncateHash(value?: string, visible = 5) {
  if (!value) return "-";
  if (value.length <= visible) return value;
  return value.slice(0, visible) + "...";
},

/** Helpers */
 safe(v: any, fallback = "-") {
  if (v === null || v === undefined || v === "") return fallback;
  return String(v);
}
, nf(v: any) {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  return Number.isFinite(n) ? n.toLocaleString() : String(v);
}
, firstAllowedRoute(
  options: Array<{ perm: string; url: string }>,
  perms: Set<string>
) {
  return options.find((o) => perms.has(o.perm))?.url ?? null;
}
, cx(...cls: Array<string | false | null | undefined>) {
  return cls.filter(Boolean).join(" ");
}

, getDir(): "ltr" | "rtl" {
  const d = document?.documentElement?.getAttribute("dir");
  return (d === "rtl" ? "rtl" : "ltr") as "ltr" | "rtl";
}
, yearsBetween(fromISO: string, to = new Date()) {
  const d = new Date(fromISO);
  if (Number.isNaN(d.getTime())) return null;

  let years = to.getFullYear() - d.getFullYear();
  const m = to.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && to.getDate() < d.getDate())) years -= 1;
  return years;
}

, isAtLeast18(dobISO: string) {
  const y =helper. yearsBetween(dobISO);
  return y != null && y >= 18;
},
formatMonthShort(monthStr?: string) {
  if (!monthStr) return "-";

  const date = new Date(monthStr);
  if (isNaN(date.getTime())) return monthStr;

  const month = date.toLocaleString("en-US", { month: "short" }); // Dec
  const year = String(date.getFullYear()).slice(-2); // 26

  return `${month} ${year}'`;
},validateStrongPassword(password: string) {
  const minLength = 8;
  const upper = /[A-Z]/;
  const lower = /[a-z]/;
  const number = /[0-9]/;
  const special = /[!@#$%^&*(),.?":{}|<>]/;

  if (password.length < minLength) return `Password must be at least ${minLength} characters`;
  if (!upper.test(password)) return "Password must contain at least 1 uppercase letter";
  if (!lower.test(password)) return "Password must contain at least 1 lowercase letter";
  if (!number.test(password)) return "Password must contain at least 1 number";
  if (!special.test(password)) return "Password must contain at least 1 special character";

  return null; // valid
}
, getRisk(days: number) {
  if (days >= 120) return "Critical";
  if (days >= 90) return "High";
  if (days >= 60) return "Medium";
  return "Low";
}

, riskBadgeClass(risk: string) {
  if (risk === "Critical") return "bg-red-500/10 border-red-500/20 text-red-600";
  if (risk === "High") return "bg-orange-500/10 border-orange-500/20 text-orange-600";
  if (risk === "Medium") return "bg-yellow-500/10 border-yellow-500/20 text-yellow-600";
  return "bg-muted border-border text-muted-foreground";
}

}